import React, { useState } from "react";
import { useLaunchParams } from "@telegram-apps/sdk-react";
import { DesktopLayout } from "@/layouts/DesktopLayout";
import { ExchangeConnectList } from "@/components/ExchangeConnectList";
import { AutotradeTriggerManager } from "@/components/AutotradeTriggerManager";
import { NeedHelpCard } from "@/components/NeedHelpCard";

export const SettingsPageDesktop: React.FC = () => {
  const launchParams = useLaunchParams();
  const userId = launchParams.initData?.user?.id?.toString() || "";
  const [guideRequest, setGuideRequest] = useState(0);

  return (
    <DesktopLayout
      pageTitle="Settings"
      pageDescription="Manage your exchange connections and autotrade settings"
      showRightSidebar={false}
    >
      <div className="flex items-start gap-6 pb-8">
        <div className="min-w-0 flex-1">
          <ExchangeConnectList userId={userId} guideRequest={guideRequest} />
        </div>
        <div className="flex w-[400px] shrink-0 flex-col gap-6 2xl:w-[460px]">
          <AutotradeTriggerManager userId={userId} />
          <NeedHelpCard onViewGuide={() => setGuideRequest((n) => n + 1)} />
        </div>
      </div>
    </DesktopLayout>
  );
};
